import { bootstrapApplication } from '@angular/platform-browser';
import { CloudAppComponent } from './app/cloud/cloud-app.component';
import { provideHttpClient } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { CloudApiService } from './app/cloud/services/cloud-api.service';
import { environment } from './environments/environment';
import { cloudAppConfig } from './app/cloud/cloud-app.config';

// Set flag to prevent ApiService initialization in cloud mode
// ApiService is for connecting to Crestron devices via JSON-RPC WebSocket
// Cloud mode uses CloudApiService to connect to Device Registry API via REST
(window as any).__CLOUD_MODE__ = true;

bootstrapApplication(CloudAppComponent, {
    ...cloudAppConfig,
    providers: [
        ...(cloudAppConfig.providers || []),
        provideHttpClient(),
        CloudApiService,
        { provide: APP_BASE_HREF, useValue: environment.baseUrl }
    ]
}).then(() => {
    hideSplash();
    // Safety fallback if router-less
    setTimeout(() => hideSplash(), 1000);
}).catch(err => console.error(err));

// Unified splash hide supporting #app-splash or .app-splash
function hideSplash() {
    const splash = document.getElementById('app-splash') || document.querySelector('.app-splash') as HTMLElement | null;
    if (!splash) return;
    if (!splash.classList.contains('splash-hide')) {
        splash.classList.add('splash-hide');
    }
    setTimeout(() => {
        if (splash && splash.parentElement) splash.remove();
    }, 350);
}

// Hard timeout: ensure removal even if bootstrap logic above fails early
setTimeout(() => hideSplash(), 5000);
